<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <CheckLatestPartsForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CheckLatestPartsForm from '@/components/organisms/master/form/CheckLatestPartsForm'

export default {
  name: 'CheckLatestPartsPage',

  components: {
    CheckLatestPartsForm,
  },
}
</script>
